<template>
  <AddFlexLeagueScores
    v-if="!isTeamLeague || isMixedLeague"
    :id="id"
    :mixed="isMixedLeague"
  />
  <AddTeamLeagueScores v-else :id="id" />
</template>
<script>
import AddFlexLeagueScores from '@/views/Leagues/AddFlexLeagueScores.vue';
import AddTeamLeagueScores from '@/views/Leagues/AddTeamLeagueScores.vue';

export default {
  name: 'AddLeagueScores',
  components: {
    AddFlexLeagueScores,
    AddTeamLeagueScores,
  },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      league: null,
    };
  },
  mounted() {
    this.getLeague();
  },
  computed: {
    isTeamLeague() {
      if (this.league && this.league.type.includes('team')) {
        return true;
      }
      return false;
    },
    isMixedLeague() {
      return this.league && this.league.type === 'mixed';
    },
  },
  methods: {
    getLeague() {
      return this.axios
        .get(`/leagues/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.league = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
